<i18n>
{
  "fr": {
    "connectionProperty": "Raccordement de la propriété",
    "connectProperty": "La propriété est raccordée à un réseau",
    "waterRainNotConnect":"Les eaux pluviales de la propriété sont raccordées à un réseau d’eaux pluviales",
    "informationConnection": "Informations sur le branchement :",
    "informationWorkOfConnection": "Informations sur les travaux du branchement : ",
    "sameAddress": "Adresse du branchement identique à l'adresse de la propriété",
    "connectionNumber":"N° du branchement SIG (après mise à jour SIG) : ",
    "typeOfConnection": "Type de branchement : ",
    "effluentConnected": "Effluent raccordé : ",
    "typeOfNetwork": "Type de réseau : ",
    "otherNetworkPropertyComment": "Commentaires :",
    "throughGargoyle": "Par l’intermédiaire d’une gargouille",
    "visitingAndUncloggingDevice": "Possédant un dispositif de visite et désobstruction :",
    "propertyNetwork": "Propriété du réseau : ",
    "accessibleVisitingDevice": "Dispositif de visite accessible en limite de propriété : ",
    "connectionRequestDate": "Date de la demande de raccordement : ",
    "quotationNumber": "N° du devis : " ,
    "quotationSendDate": "Date d’envoi du devis : ",
    "orderNumber": "N° commande client : ",
    "orderDate": "Date commande client : ",
    "invoiceNumber": "N° facture client : ",
    "workStartDate": "Date début de travaux programmée : ",
    "workDuration": "Durée estimative des travaux : ",
    "workEndDate": "Date de fin de travaux effective : ",
    "town": "Commune :",
    "street": "Rue :",
    "streetNumber": "Numéro de police :",
    "zip": "Code postal :",
    "acceptanceReport": "Procès verbal de réception : ",
    "commentsRelatingToTheConnection": "Commentaires relatifs au branchement: "
    }
}
</i18n>

<template>
  <div id="conception-data" class="block">
    <template v-if="property.raccordement">
      <Content :title="this.$i18n.t('connectionProperty')" :only="true">
        <span slot="main-text-1">
          <p class="text">
            <template v-if="property.raccordement.connectedNetwork == 'oui'">
              <v-icon name="check" />
            </template>
            <template v-else-if="property.raccordement.connectedNetwork == 'partiellement'">
              <v-icon name="exclamation-circle" class="warning" />
            </template>
            <template v-else>
              <v-icon name="times" class="nok" />
            </template>
            {{ $t('connectProperty') }}
          </p>
          <p
            class="text"
            v-if="property.raccordement.connectedNetwork == 'oui'  || property.raccordement.connectedNetwork == 'partiellement'"
          >
            <template
              v-if="this.getValue(property.raccordement.epConnectedPublicSanitationNetwork)"
            >
              <v-icon name="check" />
            </template>
            <template v-else>
              <v-icon name="times" class="nok" />
            </template>
            {{ $t('waterRainNotConnect') }}
          </p>
          <p class="text" v-else>
            <template>
              <v-icon name="times" class="nok" />
            </template>
            {{ $t('waterRainNotConnect') }}
          </p>
        </span>
      </Content>
      <template v-if="property.raccordement.connections.length > 0">
        <b-row v-for="(connection, index) in property.raccordement.connections" :key="index">
          <b-col md="12">
            <h4 class="header-title">Branchement {{ index + 1 }}</h4>
          </b-col>
          <b-col md="12" v-if="connection.attachement">
            <FilesData :attachment="connection.attachement" />
          </b-col>

          <b-col md="12">
            <b-row>
              <b-col md="6" sm="12" v-if="['oui', 'partiellement'].includes(property.raccordement.connectedNetwork)">
                <h4>{{ $t('informationConnection') }}</h4>
                <p class="text">
                  <template v-if="getValue(connection.sameAddressAsProperty)">
                    <v-icon name="check" />
                  </template>
                  <template v-else>
                    <v-icon name="times" class="nok" />
                  </template>
                  {{ $t('sameAddress')}}
                </p>
                <template v-if="getValue(connection.sameAddressAsProperty)"></template>
                <template v-else>
                  <p class="text">
                    {{ $t('town') }}
                    <span>{{ connection.town }}</span>
                  </p>
                  <p class="text">
                    {{ $t('street') }}
                    <span>{{ connection.street }}</span>
                  </p>
                  <p class="text">
                    {{ $t('streetNumber') }}
                    <span>{{ connection.streetNumber }}</span>
                  </p>
                  <p class="text">
                    {{ $t('zip') }}
                    <span>{{ connection.zip }}</span>
                  </p>
                </template>
                <p class="text">
                  {{ $t('connectionNumber') }}
                  <span>{{ connection.connectionNumber }}</span>
                </p>
                <p class="text">
                  {{ $t('typeOfConnection') }}
                  <span>{{ getTypeOfConnection(connection.typeOfConnection) }}</span>
                </p>
                <p class="text">
                  {{ $t('typeOfNetwork') }}
                  <span>{{ connection.networkType }}</span>
                </p>
                <p class="text">
                  {{ $t('propertyNetwork') }}
                  <span>{{ connection.networkProperty }}</span>
                </p>
                <p class="text" v-if="connection.networkProperty == 'Autres'">
                  {{ $t('otherNetworkPropertyComment') }}
                  <span>{{ connection.otherNetworkPropertyComment }}</span>
                </p>
                <p class="text" v-if="connection.networkType == 'Eaux pluviales'">
                  <template v-if="connection.throughGargoyle">
                    <v-icon name="check" />
                  </template>
                  <template v-else>
                    <v-icon name="times" class="nok" />
                  </template>
                  {{ $t('throughGargoyle') }}
                </p>
                <p class="text">
                  {{ $t('visitingAndUncloggingDevice')
                  }}
                  <span>{{ connection.visitingAndUncloggingDevice }}</span>
                </p>
                <p class="text">
                  {{ $t('commentsRelatingToTheConnection') }}
                  <span>{{ connection.commentsRelatingToTheConnection }}</span>
                </p>
                <p class="text" v-if="getValue(connection.visitingAndUncloggingDevice)">
                  {{ $t('accessibleVisitingDevice')
                  }}
                  <span>{{ connection.accessibleVisitingDevice }}</span>
                </p>
              </b-col>
              <b-col md="6" sm="12">
                <h4>{{ $t('informationWorkOfConnection') }}</h4>
                <p class="text">
                  {{ $t('connectionRequestDate') }}
                  <span
                    v-if="connection.connectionRequestDate"
                  >{{ connection.connectionRequestDate | moment('DD/MM/YYYY')}}</span>
                </p>
                <p class="text">
                  {{ $t('quotationNumber') }}
                  <span>{{ connection.quotationNumber }}</span>
                </p>
                <p class="text">
                  {{ $t('quotationSendDate') }}
                  <span
                    v-if="connection.quotationSendDate"
                  >{{ connection.quotationSendDate | moment('DD/MM/YYYY')}}</span>
                </p>
                <p class="text">
                  {{ $t('orderNumber') }}
                  <span>{{ connection.orderNumber }}</span>
                </p>
                <p class="text">
                  {{ $t('orderDate') }}
                  <span
                    v-if="connection.orderDate"
                  >{{ connection.orderDate | moment('DD/MM/YYYY')}}</span>
                </p>
                <p class="text">
                  {{ $t('invoiceNumber') }}
                  <span>{{ connection.invoiceNumber }}</span>
                </p>
                <p class="text">
                  {{ $t('workStartDate') }}
                  <span
                    v-if="connection.workStartDate"
                  >{{ connection.workStartDate| moment('DD/MM/YYYY') }}</span>
                </p>
                <p class="text">
                  {{ $t('workDuration') }}
                  <span
                    v-if="connection.workDuration"
                  >{{ connection.workDuration | moment('DD/MM/YYYY')}}</span>
                </p>
                <p class="text">
                  {{ $t('workEndDate') }}
                  <span
                    v-if="connection.workEndDate"
                  >{{ connection.workEndDate | moment('DD/MM/YYYY')}}</span>
                </p>
                <p class="text">
                  {{ $t('acceptanceReport') }}
                  <span>{{ connection.acceptanceReport }}</span>
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
    </template>
  </div>
</template>
<script>
import Content from '../Content';
import FilesData from './FilesData';
import { mapState } from 'vuex';

export default {
  name: 'ConnectionData',
  components: {
    Content,
    FilesData,
  },
  computed: {
    ...mapState({ property: state => state.refProperties.property }),
  },
  methods: {
    getValue(value) {
      return value == 'oui' ? true : false;
    },
    getTypeOfConnection: function(value) {
      const options = {
        'branchement-neuf': 'Branchement Neuf',
        'branchement-existant': 'Branchement Existant',
        'reutilisation-branchement': 'Réutilisation de branchement',
      };
      return options[value];
    },
  },
};
</script>
